import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faSpinner } from '@/fontawesome';
import Modal from '@/components/ui/Modal';

interface DisconnectSCNModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}

export default function DisconnectSCNModal({ isOpen, onClose, onConfirm, isLoading }: DisconnectSCNModalProps) {
  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="SCN-Verbindung trennen"
      icon={<FontAwesomeIcon icon={faExclamationTriangle} className="w-5 h-5 text-yellow-600" />}
      maxWidth="md"
      closeDisabled={isLoading}
    >
      <div className="p-6">
        {/* Warning Message */}
        <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-4 mb-6">
          <p className="text-sm text-yellow-800 dark:text-yellow-200">
            Sind Sie sicher, dass Sie die SCN-Verbindung trennen möchten?
          </p>
          <p className="text-sm text-yellow-800 dark:text-yellow-200 mt-2">
            Nach dem Trennen erhalten Sie keine automatischen Benachrichtigungen mehr über Simple Cloud Notifications.
          </p>
        </div>

        {/* Buttons */}
        <div className="flex justify-end space-x-3">
          <button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-600 border border-gray-300 dark:border-gray-500 rounded-md hover:bg-gray-200 dark:hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-500 disabled:opacity-50 cursor-pointer"
          >
            Abbrechen
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            disabled={isLoading}
            className="px-4 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer flex items-center"
          >
            {isLoading && <FontAwesomeIcon icon={faSpinner} className="w-4 h-4 mr-2 animate-spin" />}
            Verbindung trennen
          </button>
        </div>
      </div>
    </Modal>
  );
}
